// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__ng-IB","rootCenter":"LoadMoreObserver_rootCenter__2Y0Pf","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1wEz7"};